import { Bootstrapper, whenIdle, whenVisible } from '@sitepark/dom-bootstrapper';

Bootstrapper.register(
	'data-sp-annotationviewer',
	whenIdle(async () => (await import('@sitepark/component-annotation-viewer')).AnnotationViewer),
);
Bootstrapper.register(
	'data-sp-print-link-references',
	whenIdle(async () => (await import('@sitepark/print-basics')).PrintLinkFootnotes),
);
Bootstrapper.register(
	'data-sp-navigation-multilevelpush',
	whenIdle(async () => (await import('../components/Navigation')).Navigation),
);
Bootstrapper.register(
	'data-sp-table',
	whenVisible(async () => (await import('@sitepark/component-table')).CompatTableInitializer),
);
Bootstrapper.register(
	'data-sp-offcanvas',
	whenIdle(async () => (await import('@sitepark/component-offcanvas')).Offcanvas),
);
Bootstrapper.register(
	'data-sp-picture-gallery',
	whenVisible(async () => (await import('../components/photoswipe/CustomerGalleryZoom')).CustomerGalleryZoom),
);
Bootstrapper.register(
	'data-sp-panelgroup',
	whenVisible(async () => (await import('@sitepark/component-panel-group')).PanelGroup),
);
Bootstrapper.register(
	'data-sp-figure-zoom',
	whenVisible(async () => (await import('../components/photoswipe/CustomerPictureZoom')).CustomerPictureZoom),
);

Bootstrapper.register(
	'data-sp-navigation-multilevelpush',
	whenIdle(async () => (await import('../components/Navigation')).Navigation),
);

Bootstrapper.register(
	'data-sp-map',
	whenVisible(async () => (await import('../components/map/Map')).Map),
);
Bootstrapper.register(
	'data-sp-youtube-shorts-slider',
	whenVisible(async () => (await import('../components/swiper/YoutubeShortsSliderApp')).YoutubeShortsSliderApp),
);
Bootstrapper.register(
	'data-sp-topic-slider',
	whenVisible(async () => (await import('../components/swiper/TopicSlider')).TopicSlider),
);

Bootstrapper.register(
	'data-sp-newsletter-registration',
	whenIdle(async () => (await import('@sitepark/component-newsletter')).Registration),
);

Bootstrapper.register('data-sp-webaccount-lightbox', async () => (await import('@sitepark/component-webaccount-lightbox')).WebaccountLightbox);

Bootstrapper.register(
	'data-sp-privacy-barrier',
	whenIdle(async () => (await import('@sitepark/component-privacy-barrier')).PrivacyBarrier),
);
Bootstrapper.register(
	'data-sp-privacy-barrier-dialog',
	whenIdle(async () => (await import('@sitepark/component-privacy-barrier')).PrivacyBarrierInDialog),
);
Bootstrapper.register('data-sp-dialog', async () => (await import('@sitepark/component-dialog')).DialogController);
Bootstrapper.register('data-sp-dialog-controller', async () => (await import('@sitepark/component-dialog')).DialogController);

Bootstrapper.register(
	'data-sp-consent-banner',
	whenIdle(async () => (await import('@sitepark/component-consent')).ConsentBanner),
);
Bootstrapper.register(
	'data-sp-protectioncookiesusage',
	whenIdle(async () => (await import('@sitepark/component-consent')).DataProtectionCookiesUsage),
);

Bootstrapper.register(
	'data-sp-collapsible',
	whenIdle(async () => (await import('@sitepark/component-collapsible')).Collapsible),
);

Bootstrapper.register(
	'data-sp-iframe',
	whenIdle(async () => (await import('../components/IFrame')).Iframe),
);

Bootstrapper.register(
	'data-sp-emergencymessages',
	whenIdle(async () => (await import('@sitepark/component-emergency-messages')).EmergencyMessages),
);
Bootstrapper.register(
	'data-sp-event-slider-app',
	whenIdle(async () => (await import('../components/swiper/EventSliderApp')).EventSliderApp),
);
Bootstrapper.register(
	'data-sp-event-news-app',
	whenIdle(async () => (await import('../components/swiper/NewsSliderApp')).NewsSliderApp),
);
Bootstrapper.register(
	'data-sp-image-gallery-unshown-counter',
	whenIdle(async () => (await import('../components/photoswipe/UnshownImageCounter')).UnshownImageCounter),
);
Bootstrapper.register(
	'data-sp-card-list-app',
	whenIdle(async () => (await import('../react/apps/CardListApp')).CardListApp),
);

Bootstrapper.register(
	'data-sp-email',
	whenIdle(async () => (await import('@sitepark/component-email')).Email),
);
Bootstrapper.registerImport('data-ilink', () => import('@sitepark/component-ilink'), 'ILink');
Bootstrapper.registerImport('data-sp-central-search-app', () => import('../react/search/apps/CentralSearchApp'), 'CentralSearchApp');
Bootstrapper.registerImport('data-sp-gallery-slider', () => import('../components/swiper/GallerySlider'), 'GallerySlider');
Bootstrapper.registerImport('data-sp-quick-search-app', () => import('../react/search/apps/QuickSearchApp'), 'QuickSearchApp');
Bootstrapper.registerImport('data-sp-event-search-app', () => import('../react/search/apps/EventSearchApp'), 'EventSearchApp');
Bootstrapper.registerImport('data-sp-news-slider-app', () => import('../react/apps/NewsSliderApp'), 'NewsSliderApp');
Bootstrapper.registerImport('data-sp-teaser-slider-app', () => import('../components/swiper/TeaserSliderApp'), 'TeaserSliderApp');
Bootstrapper.registerImport('data-sp-teaserlist-app', () => import('../react/apps/TeaserListApp'), 'TeaserListApp');
Bootstrapper.registerImport('data-sp-citygov-search-app', () => import('../react/search/apps/CityGovSearchApp'), 'CityGovSearchApp');
Bootstrapper.registerImport('data-sp-itb-citygov-search-app', () => import('../react/search/apps/ITBCityGovSearchApp'), 'ITBCityGovSearchApp');
Bootstrapper.registerImport('data-sp-citygov-az-search-app', () => import('../react/search/apps/CityGovAZSearchApp'), 'CityGovAZSearchApp');
/* This should be loaded eagerly */
Bootstrapper.register('data-sp-masonry-app', async () => (await import('../react/apps/MasonryApp')).MasonryApp);
Bootstrapper.registerImport('data-sp-eyeable-lang-switcher', () => import('../react/apps/EyeAbleLangSwitcherApp'), 'EyeAbleLangSwitcherApp');

// Bootstrapper.register(
// 	'data-sp-voting-rating-item',
// 	whenVisible(async () => (await import('@sitepark/component-voting')).RatingItem),
// );
// Bootstrapper.register(
// 	'data-sp-clipboard',
// 	whenVisible(async () => (await import('@sitepark/component-clipboard')).CopyToClipboard),
// );
